import React from "react";
import { colors, spacing, radius, typography } from "../theme/tokens";

/**
 * EmptyState — estado vacío curado y consistente.
 *
 * @param {string} message — texto principal (default "No se encontraron documentos")
 * @param {React.ReactNode} icon — ilustración/icono custom. Default: documento genérico.
 * @param {React.ReactNode} action — botón o CTA opcional debajo del mensaje.
 */
const EmptyState = ({
    message = "No se encontraron documentos",
    icon,
    action,
}) => {
    const defaultIcon = (
        <svg
            style={styles.icon}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
        </svg>
    );

    return (
        <div style={styles.container} role="status">
            <div style={styles.content}>
                {icon || defaultIcon}
                <p style={styles.message}>{message}</p>
                {action && <div style={styles.action}>{action}</div>}
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: `${spacing[7]}px ${spacing[4]}px`,
        backgroundColor: colors.gray50,
        borderRadius: radius.md,
        border: `1px solid ${colors.border}`,
    },
    content: {
        textAlign: "center",
        maxWidth: 320,
    },
    icon: {
        width: 64,
        height: 64,
        color: colors.gray400,
        margin: `0 auto ${spacing[3]}px`,
    },
    message: {
        color: colors.textMuted,
        fontSize: typography.fontSize.md,
        fontStyle: "italic",
        margin: 0,
    },
    action: {
        marginTop: spacing[4],
    },
};

export default EmptyState;
